module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('vue-table', {
    attrs: {
      "tableData": _vm.documents,
      "showEdit": true,
      "showDelete": true,
      "fields": _vm.fields,
      "tableTitle": _vm.tableTitle
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61c9ba4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/library/components/LibrarySection.vue
// module id = 2203
// module chunks = 1